import React from 'react';
import { useIntl } from 'react-intl';
import { RemoteCommandStatusChip } from './RemoteCommandStatusChip';
import { commandLabel } from '../remoteCommandsUtils';

/**
 * One command: what, status, who (null `requestedByName` = the account owner),
 * when (formatted by the caller, user's time zone) and the error, if any.
 */
export const RemoteCommandItem = ({ command, formatDateTime, as: Tag = 'div', className = '' }) => {
	const { messages, formatMessage } = useIntl();
	const name = command.requestedByName || messages['oemDataModal_remote_accountOwner'];
	const when = formatDateTime(command.requestedAt) ?? messages['oemDataModal_notAvailable'];

	return (
		<Tag className={`oem-remote-item ${className}`} data-testid="oem-remote-item">
			<div className="oem-remote-item-header">
				<span className="oem-remote-item-command">{commandLabel(command.command, messages)}</span>
				<RemoteCommandStatusChip status={command.status} />
			</div>
			<div className="oem-remote-item-meta">
				{formatMessage({ id: 'oemDataModal_remote_requestedBy' }, { name, when })}
			</div>
			{command.errorMessage && <div className="oem-remote-item-error">{command.errorMessage}</div>}
		</Tag>
	);
};
